import React from "react";
import "./MainMenu.css";
import { useNavigate, NavLink } from "react-router-dom";

export default function MainMenu() {
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await fetch("https://spst.in/myapp/api/logout.php", {
                method: "POST",
            });

            localStorage.removeItem("auth");

            // Trigger logout in all tabs
            localStorage.setItem("logout", Date.now());

            navigate("/");
        } catch (error) {
            console.error("Logout failed:", error);
        }
    };

    return (
        <div className="main-menu-wrapper">

            <div className="main-menu-container">

                {/* Dashboard */}
                <NavLink
                    to="../Dashboard"
                    className={({ isActive }) =>
                        `main-menu-card ${isActive ? "active" : ""}`
                    }
                >
                    <div className="menu-icon dashboard-icon">
                        <i className="fa fa-tachometer"></i>
                    </div>

                    <div className="menu-info">
                        <span className="menu-small-title">
                            Overview
                        </span>

                        <span className="menu-title">
                            Dashboard
                        </span>
                    </div>

                    <div className="menu-arrow">
                        <i className="fa fa-angle-right"></i>
                    </div>
                </NavLink>


                {/* Patients */}
                <NavLink
                    to="../Newprofile"
                    className={({ isActive }) =>
                        `main-menu-card ${isActive ? "active" : ""}`
                    }
                >
                    <div className="menu-icon patient-icon">
                        <i className="fa fa-address-book-o"></i>
                    </div>

                    <div className="menu-info">
                        <span className="menu-small-title">
                            Management
                        </span>

                        <span className="menu-title">
                            Patients
                        </span>
                    </div>

                    <div className="menu-arrow">
                        <i className="fa fa-angle-right"></i>
                    </div>
                </NavLink>


                {/* Patient Visits */}
                <NavLink
                    to="../Visiting"
                    className={({ isActive }) =>
                        `main-menu-card ${isActive ? "active" : ""}`
                    }
                >
                    <div className="menu-icon visit-icon">
                        <i className="fa fa-address-card-o"></i>
                    </div>

                    <div className="menu-info">
                        <span className="menu-small-title">
                            Records
                        </span>

                        <span className="menu-title">
                            Patient Visits
                        </span>
                    </div>

                    <div className="menu-arrow">
                        <i className="fa fa-angle-right"></i>
                    </div>
                </NavLink>


                {/* Exit */}
                <div
                    className="main-menu-card logout-card"
                    onClick={handleLogout}
                >
                    <div className="menu-icon logout-icon">
                        <i className="fa fa-power-off"></i>
                    </div>

                    <div className="menu-info">
                        <span className="menu-small-title">
                            Account
                        </span>

                        <span className="menu-title">
                            Exit
                        </span>
                    </div>

                    <div className="menu-arrow">
                        <i className="fa fa-angle-right"></i>
                    </div>
                </div>

            </div>

        </div>
    );
}